import type {
    AppSubmodule,
    ExposedMenu,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { SETTINGS_SECTIONS } from '@moniebook-web/types';

export const saleSettingsMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 1,
            name: 'Taxes',
            to: '/dashboard/settings/taxes',
            accessCodeList: ['MANAGE_TAX'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 3,
            name: 'Register configurations',
            to: '/dashboard/settings/register-configurations',
            accessCodeList: ['MANAGE_REGISTER'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 5,
            name: 'Receipt',
            to: '/dashboard/settings/receipt-settings',
            accessCodeList: ['MANAGE_RECEIPT'],
            showInSettings: true,
            featureFlag: 'moniebook.pos.displayOldReceiptMenuLabel',
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 6,
            name: 'Receipt & invoice settings',
            to: '/dashboard/settings/receipt-settings',
            accessCodeList: ['MANAGE_RECEIPT'],
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableAdvancedReceiptCustomization',
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 7,
            name: 'Payment restriction',
            to: '/dashboard/settings/payment-restrictions',
            accessCodeList: ['MANAGE_PAYMENT_RESTRICTION'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 8,
            name: 'Dockets',
            to: '/dashboard/settings/dockets',
            accessCodeList: [],
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableDocketsDashboard',
        },
    ] as SideLink[],
    modules: [],
    subModules: [
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 1,
            name: 'Taxes',
            to: '/dashboard/settings/taxes',
            accessCodeList: ['MANAGE_TAX'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 3,
            name: 'Register configurations',
            to: '/dashboard/settings/register-configurations',
            accessCodeList: ['MANAGE_REGISTER'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 5,
            name: 'Receipt',
            to: '/dashboard/settings/receipt-settings',
            accessCodeList: ['MANAGE_RECEIPT'],
            showInSettings: true,
            featureFlag: 'moniebook.pos.displayOldReceiptMenuLabel',
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 6,
            name: 'Receipt & invoice settings',
            to: '/dashboard/settings/receipt-settings',
            accessCodeList: ['MANAGE_RECEIPT'],
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableAdvancedReceiptCustomization',
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 7,
            name: 'Payment restriction',
            to: '/dashboard/settings/payment-restrictions',
            accessCodeList: ['MANAGE_PAYMENT_RESTRICTION'],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 8,
            name: 'Dockets',
            to: '/dashboard/settings/dockets',
            accessCodeList: [],
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableDocketsDashboard',
        },
    ] as AppSubmodule[],
};
